import { IconProps } from './types';

import CommentSvg from 'images/microsoft-logo.svg';

const MicrosoftLogo = ({ className }: IconProps) => {
  return <img className={className} src={CommentSvg} />;
};

export default MicrosoftLogo;
